import api from '../api/api'
import router from "../router";
import {SET_CURR_POSITION, SET_SITE_CONFIG} from './mutation-types'

export default {
  //获取配置
  async getSiteConfig({ commit, state }) {
    let json = await api.common.config()
    if (json.code === 200) {
      commit(SET_SITE_CONFIG, json.data)
    } else {
      commit(SET_SITE_CONFIG, null)
    }
    return state.config
  },

  // 获取当前位置
  async getCurrPosition({ commit, state }) {
    console.log('当前路由=>',router.currentRoute.value.params)
    commit(SET_CURR_POSITION, {'id':"1", 'name':'heyong'})
    return state.curr_position
  }
}
